module.exports = __webpack_public_path__ + "img/IoTServe2_1.d7324086.png";